import React from 'react';
import Helmet from 'react-helmet';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import HelpCenter from '../components/HelpCenter';

const HelpPage = () => {
  return (
    <Layout>
      <SEO
        title="帮助中心 - 魔鬼鱼订货平台常见问题（入驻/进货/物流）"
        description="魔鬼鱼订货平台帮助中心，为您提供宠物行业 B2B 订货常见问题解答，涵盖入驻注册、账号管理、货品采购、仓配物流、一件代发等全方位 FAQ 指南。"
        path="/help"
      />
      <Helmet>
        <meta
          name="keywords"
          content="魔鬼鱼订货平台, 帮助中心, 宠物B2B订货, 常见问题, FAQ, 宠物店入驻, 宠物批发, 一件代发, 区域控货"
        />
        <script type="application/ld+json" key="breadcrumb">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://www.mantas.cn'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: '帮助中心',
                item: 'https://www.mantas.cn/help'
              }
            ]
          })}
        </script>
        <script type="application/ld+json" key="faqpage">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '哪些商户可以进入魔鬼鱼订货平台批发产品？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '平台面向全国宠物行业 B 端商家开放入驻，包含线下宠物门店、宠物医院、宠物美容店、家庭猫舍/犬舍、宠物寄养中心等正规经营商户等。'
                }
              },
              {
                '@type': 'Question',
                name: '申请进入魔鬼鱼订货平台需要提供什么资料？是否收费？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '入驻仅需提供门店营业执照/经营实景照片即可完成资质审核；平台免费使用全部订货功能，无年费、无开户费、无隐性服务费。'
                }
              },
              {
                '@type': 'Question',
                name: '提交审核资料后，多久可以审核通过？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '工作日 1-2 小时内完成人工审核，非工作日最晚次日上午完成审核，审核通过后即可查看批发底价、正常下单采购。'
                }
              },
              {
                '@type': 'Question',
                name: '平台是否支持多员工协同管理账号？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '支持。主账号可免费绑定多名员工子账号，适配宠物店、宠物医院，猫咖、多门店统一管理需求。'
                }
              },
              {
                '@type': 'Question',
                name: '子账号可以共享购物车和历史订单吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '可以。主账号与所有子账号购物车、历史采购订单、进货价格、货品明细全部实时共享，老板无需线下和店长反复对账，手机随时随地一键查看全部进货记录。'
                }
              },
              {
                '@type': 'Question',
                name: '平台支持区域专供、渠道隔离控货吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '支持平台级技术隔离管控。可设置城市区域专供货品（如上海专属），非授权区域门店无法搜索、无法下单；同时支持渠道隔离，可区分宠物医院/宠物门店专属货品，精准防止跨渠道、跨区域串货乱价。'
                }
              },
              {
                '@type': 'Question',
                name: '平台一共有多少供应商，货品品类齐全吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '平台汇聚全国 200+ 源头宠物供应商，1000+ 宠物品牌，覆盖主粮、零食、冻干、湿粮、驱虫药品、宠物洗护、繁育消杀用品、猫砂耗材等全品类货品，一站式配齐门店全部货源。'
                }
              },
              {
                '@type': 'Question',
                name: '为什么部分商品我搜索不到？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '可能性为搜索关键词不对，导致产品搜索不到，或该商品为定向渠道/定向区域专供款，当前账号所属区域、经营资质暂无采购权限，系统自动隐藏货品。可联系订货助手 - 椰子进行咨询了解。'
                }
              },
              {
                '@type': 'Question',
                name: '平台下单后多久可以发货？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '工作日大部分订单 48 小时内完成发货出库，无需漫长等待。易变质产品，全程恒温冷链仓储 + 冷链运输，杜绝货品变质、受潮、软化问题。'
                }
              },
              {
                '@type': 'Question',
                name: '物流进度在哪里查看，会有提醒吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '订单发货后，系统自动通过魔鬼鱼订货平台服务号推送物流通知，揽收、中转、派送全节点实时同步，无需手动查询物流，运输动态一键可查。'
                }
              },
              {
                '@type': 'Question',
                name: '平台支持宠物粮砂一件代发服务吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '支持。部分猫粮、狗粮、猫砂等大体积、重重量刚需货品，商家无需大批量囤货。'
                }
              },
              {
                '@type': 'Question',
                name: '一件代发适合什么类型门店？有什么优势？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '非常适合社区单体宠物店、夫妻店、家庭繁育猫舍。门店仅需摆放空袋/2-3 件样品展示，客户下单后直接平台代发直达客户家中；零库存压力、加快货品周转，省去门店重物配送人力成本，同时提升客户提货体验。'
                }
              },
              {
                '@type': 'Question',
                name: '平台客服服务时间是多久？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '线上客服周一至周日 9:00-18:00，全天候解答下单、权限、物流、售后各类问题。'
                }
              }
            ]
          })}
        </script>
        <script type="application/ld+json" key="webpage">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            '@id': 'https://www.mantas.cn/help',
            name: '帮助中心',
            url: 'https://www.mantas.cn/help',
            description: '魔鬼鱼订货平台帮助中心，为您提供宠物行业 B2B 订货常见问题解答',
            specialty: 'Customer Support'
          })}
        </script>
      </Helmet>

      <div className="help-center-page">
        <HelpCenter />
      </div>
    </Layout>
  );
};

export default HelpPage;